
import { defineComponent } from "vue";

export default defineComponent({
  name: "acoes-editar-componente",
  props: {
    rotaId: {
      type: Number,
      required: false,
    },
    rotaEdit: {
      type: String,
      required: false,
    },
    classe: {
      type: String,
      required: false,
      default: "btn btn-sm btn-primary",
    },
    iconClass: {
      type: String,
      required: false,
      default: "bi-pencil-fill",
    },
    btnText: {
      type: String,
      required: false,
      default: "",
    },
  },
});
